import { BoxProps, ColorOptions, TextInputNewProps, TextNewProps } from '@jfs/ui-new'

export const styles = {
  titleText: {
    fontSize: 12,
    color: 'BLACK_21' as ColorOptions,
    lineHeight: 21,
    fontFamily: 'jiotype-bold',
  } as TextNewProps,
  flatListHeader: {
    flexDirection: 'row',
    ph: 15,
    bg: 'BACKGROUND',
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    borderTopWidth: 1,
    borderLeftWidth: 1,
    borderRightWidth: 1,
    borderColor: 'DISABLED_GREY',
  } as BoxProps,
  keyText: {
    fontSize: 12,
    color: 'BLACK_21' as ColorOptions,
    lineHeight: 21,
    fontFamily: 'jiotype-bold',
    numberOfLines: 1,
    textAlign: 'center',
  } as TextNewProps,
  valueText: {
    fontSize: 12,
    color: 'BLACK_21' as ColorOptions,
    lineHeight: 21,
    fontFamily: 'jiotype-medium',
    textAlign: 'center',
  } as TextNewProps,
  renderItemBox: (isLastItem: boolean, showBorder: boolean) =>
    ({
      pv: 12,
      borderTopWidth: 1,
      flexDirection: 'row',
      borderLeftWidth: showBorder ? 1 : 0,
      borderRightWidth: showBorder ? 1 : 0,
      borderColor: 'DISABLED_GREY',
      borderBottomWidth: isLastItem ? 1 : 0,
      ph: 15,
      borderBottomLeftRadius: isLastItem ? 8 : 0,
      borderBottomRightRadius: isLastItem ? 8 : 0,
      backgroundColor: 'WHITE',
    } as BoxProps),
  radioButton: {
    alignSelf: 'center',
    width: 30,
  } as BoxProps,
  textinputStyle: (isEditMode: boolean) =>
    ({
      type: 'body12',
      borderColor: isEditMode ? ('#E0E0E0' as ColorOptions) : 'WHITE',
      labelPaddingBottom: 8,
      borderRadius: isEditMode ? 4 : 0,
      labelFontFamily: 'jiotype-bold',
      fontFamily: 'jiotype-medium',
      labelColor: '#757575' as ColorOptions,
      labelFontSize: 12,
      fontSize: 12,
      selectionColor: isEditMode ? 'BLUE' : 'TRANSPARENT',
      paddingVertical: 8,
      color: 'BLACK_21' as ColorOptions,
      onFocusBorderWidth: isEditMode ? 1 : 0,
      paddingHorizontal: 8,
    } as unknown as TextInputNewProps),
  linkText: {
    fontSize: 12,
    color: '#0070B6' as ColorOptions,
    lineHeight: 21,
    fontFamily: 'jiotype-medium',
    textAlign: 'left',
  } as TextNewProps,
}
